import { Box, Container, Typography, Grid, useTheme, useMediaQuery, Paper } from '@mui/material';
import { motion } from 'framer-motion';

function About() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Container maxWidth="lg">
      <Box sx={{ py: { xs: 4, md: 8 } }}>
        <Grid container spacing={{ xs: 4, md: 6 }} alignItems="center">
          <Grid item xs={12} md={6}>
            <motion.div
              initial={{ opacity: 0, x: isMobile ? 0 : -50, y: isMobile ? -30 : 0 }}
              animate={{ opacity: 1, x: 0, y: 0 }}
              transition={{ duration: 0.8 }}
            >
              <Box sx={{ 
                textAlign: { xs: 'center', md: 'left' }, 
                px: { xs: 2, md: 0 },
              }}>
                <Typography variant="h3" sx={{ 
                  mb: 4, 
                  fontWeight: 'bold',
                  fontSize: { xs: '2rem', md: '3rem' },
                  background: 'linear-gradient(135deg, #E0C3FC 0%, #8EC5FC 100%)',
                  backgroundClip: 'text',
                  WebkitBackgroundClip: 'text',
                  color: 'transparent',
                  textShadow: '0 2px 10px rgba(224,195,252,0.3)',
                }}>
                  About Me
                </Typography>
                <Typography variant="h5" sx={{ 
                  mb: 3, 
                  color: 'primary.main',
                  fontSize: { xs: '1.25rem', md: '1.5rem' },
                  fontWeight: 500,
                }}>
                  Passionate About Photography
                </Typography>
                <Paper elevation={0} sx={{
                  p: 3,
                  background: 'linear-gradient(135deg, rgba(224,195,252,0.05) 0%, rgba(142,197,252,0.05) 100%)',
                  borderRadius: 4,
                  backdropFilter: 'blur(10px)',
                  border: '1px solid rgba(224,195,252,0.1)',
                }}>
                  <Typography variant="body1" sx={{ 
                    mb: 3, 
                    color: 'text.secondary', 
                    lineHeight: 1.8,
                    fontSize: { xs: '0.9rem', md: '1rem' }
                  }}>
                    Hello! I'm Aditya, a professional photographer based in India. With a keen eye for detail 
                    and a passion for capturing life's precious moments, I specialize in portrait, product, 
                    landscape, and architectural photography.
                  </Typography>
                  <Typography variant="body1" sx={{ 
                    mb: 3, 
                    color: 'text.secondary', 
                    lineHeight: 1.8,
                    fontSize: { xs: '0.9rem', md: '1rem' }
                  }}>
                    I believe that 
                    every photo tells a story, and I'm dedicated to telling yours in the most artistic and 
                    authentic way possible.
                  </Typography>
                  <Typography variant="body1" sx={{ 
                    color: 'text.secondary', 
                    lineHeight: 1.8,
                    fontSize: { xs: '0.9rem', md: '1rem' }
                  }}>
                    Whether it's a portrait session, product shoot, or capturing the beauty of architecture 
                    and landscapes, I bring creativity, professionalism, and attention to detail to every project.
                  </Typography>
                </Paper>
              </Box>
            </motion.div>
          </Grid>
          <Grid item xs={12} md={6}>
            <motion.div
              initial={{ opacity: 0, x: isMobile ? 0 : 50, y: isMobile ? 30 : 0 }}
              animate={{ opacity: 1, x: 0, y: 0 }}
              transition={{ duration: 0.8 }}
            >
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                  px: { xs: 2, md: 0 }
                }}
              >
                <Box
                  component="img"
                  src="https://images.unsplash.com/photo-1554048612-b6a482bc67e5"
                  alt="Photographer"
                  sx={{
                    width: '100%',
                    maxWidth: { xs: 350, md: 500 },
                    height: 'auto',
                    borderRadius: 4,
                    boxShadow: '0 4px 30px rgba(0,0,0,0.3)',
                    border: '1px solid rgba(224,195,252,0.1)',
                    filter: 'brightness(0.9)',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      transform: 'scale(1.02)',
                      filter: 'brightness(1)',
                      boxShadow: '0 8px 40px rgba(224,195,252,0.2)',
                    }
                  }}
                />
              </Box>
            </motion.div>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
}

export default About;
